import { API_URL } from '../../../app-config/constants';
import { SiAdminMiniUser } from '../../../types/MiniUser';
import { ObserverUserDto } from '../../../types/UserDtos';
import { get } from '../request';

export function getAdminMiniUserList(companyId: string): Promise<SiAdminMiniUser[]> {
    return get<SiAdminMiniUser[]>(`${API_URL}/companies/${companyId}/mini-users`);
}

export function search(email: string) {
    return get<ObserverUserDto[]>(`${API_URL}/users/search`, { getData: { email } });
}
